// Module
var code = "<div class=\"field\">\r\n  <label class=\"label\">LabelText</label>\r\n  <div class=\"control\">\r\n    <input class=\"input\" type=\"<%= type %>\">\r\n  </div>\r\n</div>\r\n";
// Exports
module.exports = code;